import "./Onboarding.scss";
import React, { useEffect, useRef, useState } from "react";
import {
  IonContent,
  IonIcon,
  IonLoading,
  IonPage,
  IonSlide,
  IonSlides,
  IonText,
} from "@ionic/react";
import abaxxLogo from "../../assets/svg/logoAbaxx.svg";
import { useHistory } from "react-router-dom";
import { useTracked } from "../../state";

const slideOpts = {
  initialSlide: 0,
  speed: 400,
};

const Onboarding: React.FC = () => {
  const history = useHistory();
  const slidesRef = useRef<any>(null);
  const [state, dispatch] = useTracked();
  const [loading, setLoading] = useState<boolean>(false);
  const [currentSlide, setCurrentSlide] = useState<Number>(0);

  //accessing dwn from window object
  // console.log('idDwn', window.idDwn.dwn.sdk.Cid)

  useEffect(() => {
    if (state.hasOnboarding) {
      setLoading(true);

      setTimeout(() => {
        setLoading(false);
        setTimeout(() => {
          history.replace("/", { direction: "forward" }); // @TODO: change this route to create identity route later.
        }, 1000);
      }, 2000);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.hasOnboarding]);

  const onClickPrev = () => {
    if (slidesRef.current) {
      slidesRef.current.slidePrev();
    }
  };

  const onClickNext = () => {
    if (slidesRef.current) {
      if (currentSlide === 2) {
        dispatch({ type: "setHasOnboarding", hasOnboarding: true });
      } else {
        slidesRef.current.slideNext();
      }
    }
  };

  const onSlideDidChange = async () => {
    if (slidesRef.current) {
      setLoading(true);
      const activeSlide = await slidesRef.current.getActiveIndex();
      setCurrentSlide(activeSlide);
      setLoading(false);
    }
  };

  return (
    <IonPage className="onboarding-page">
      <IonContent>
        <IonSlides
          pager={true}
          options={slideOpts}
          mode="ios"
          ref={slidesRef}
          onIonSlideDidChange={onSlideDidChange}
        >
          <IonSlide>
            <div className="slide-content-container">
              <IonIcon icon={abaxxLogo} className="app-logo" />
              <p>Your data is yours</p><p className="cut-p">{""}</p>
            </div>
          </IonSlide>
          <IonSlide>
            <div className="slide-content-container">
              <IonIcon icon={abaxxLogo} className="app-logo" />
              <p>
                We believe that better information creates a sustainable future
              </p>
            </div>
          </IonSlide>
          <IonSlide>
            <div className="slide-content-container">
              <IonIcon icon={abaxxLogo} className="app-logo" />
              <p>Verifier is your secure</p>
              <p className="cut-p">access to Abaxx Exchange</p>
            </div>
          </IonSlide>
        </IonSlides>

        {Number(currentSlide) > 0 && (
          <div className="left-btn" onClick={() => onClickPrev()}>
            <IonText>Prev</IonText>
          </div>
        )}

        <div className="right-btn" onClick={() => onClickNext()}>
          <IonText>{currentSlide === 2 ? "Start" : "Next"}</IonText>
        </div>

        <IonLoading isOpen={loading} onDidDismiss={() => setLoading(false)} />
      </IonContent>
    </IonPage>
  );
};

export default Onboarding;
